import { TokenSymbol } from '@/domain/types/TokenSymbol'

const solvbtc = '/tokens/solvBtc.png'
const sttesth = '/tokens/sttesth.svg?url'
const wsthype = '/tokens/wsthype.svg?url'
const usde = '/tokens/usde.png'
const lhype = '/tokens/lhype.png'
const buddy = '/tokens/buddy.jpg'
const feusd = '/tokens/feusd.svg?url'
const mhype = '/tokens/mhype.png'
const ubtc = '/tokens/ubtc.png'
const usdxl = '/tokens/usdxl.svg?url'
const susde = '/tokens/susde.png'
const hype = '/tokens/hype.png'
const ueth = '/tokens/ueth.png'
const steth = '/tokens/steth.svg?url'
const unknown = '/tokens/unknown.svg?url'
const usdc = '/tokens/usdc.svg?url'
const usdt0 = '/tokens/usdt0.svg?url'
const khype = '/tokens/khype.svg?url'
const hbhype = '/tokens/hbhype.svg?url'
const stkusdxl = '/tokens/stkusdxl.svg?url'
const cmeth = '/tokens/cmeth.png'
const usol = '/tokens/usol.png'
const xaut0 = '/tokens/xaut0.svg?url'
const hwhlp = '/tokens/hwhlp.svg?url'
const whlp = '/tokens/whlp.png'

/* Opengraph does not support webp */
export const tokens = {
  steth,
  usdc,
  usdt0,
  usdxl,
  susde,
  hype,
  whype: hype,
  solvbtc,
  sttesth,
  khype,
  wsthype,
  sthype: wsthype,
  ubtc,
  ueth,
  lhype,
  buddy,
  feusd,
  usde,
  mhype,
  xlhype: lhype,
  hbhype,
  stkusdxl,
  cmeth,
  usol,
  xaut0,
  hwhlp,
  whlp,
  unknown,
}

function tokenSymbolOverride(symbol: TokenSymbol): TokenSymbol {
  switch (symbol) {
    case TokenSymbol('USD₮0'):
      return TokenSymbol('USDT0')
    default:
      return symbol
  }
}

const SPOT_ASSET_PREFIX = 'https://app.hyperliquid.xyz/coins/'

export function getHyperliquidImage(symbol: TokenSymbol): string {
  return `${SPOT_ASSET_PREFIX}${symbol.toUpperCase()}_USDC.svg`
}

export function getTokenImage(symbol: TokenSymbol, host?: string): string {
  const image = tokens[tokenSymbolOverride(symbol).toLocaleLowerCase() as keyof typeof tokens]

  if (!image) {
    return getHyperliquidImage(symbol)
  }

  return host ? `${host}${image}` : image
}
